import '@sophocles/components/FormGrouper/styles.scss';

import PropTypes from 'prop-types';
import React from 'react';

class FormGrouper extends React.Component {
  render() {
    const { children, style } = this.props;

    return (
      <div className="form-grouper" style={style}>
        {children}
      </div>
    );
  }
}

FormGrouper.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  style: PropTypes.object,
};

export default FormGrouper;
